const _NEWSLETTER_FORM_ID = "b286c52c-0690-42d0-99c4-5c11b572f319"
export const SUPERSET_NEWSLETTER_FORM_ID =
  "ba525f61-6f7a-4219-b418-5318ee660a7f"
const _JOB_APPLYING_FORM_ID = "77018b4d-3c95-48ca-bec4-9938e2f0fd8c"
export const BLOG_SUBSCRIPTION_FORM_ID = "9cd609ca-6350-4264-81ba-1ea292dbd1f9"
export const TUTORIAL_GATING_FORM_ID = "503efdec-b0ae-4942-b5c5-d002ebbd9b44"
